import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

type MenuItem = { path: string; icon: string; label: string };

const inicio: MenuItem = { path: '/', icon: '📊', label: 'Dashboard' };

const secciones: { titulo: string; items: MenuItem[] }[] = [
  {
    titulo: 'ADMIN WEB',
    items: [
      { path: '/banners', icon: '🖼️', label: 'Banners' },
      { path: '/banner-texto', icon: '📢', label: 'Banner de texto' },
      { path: '/resenas', icon: '⭐', label: 'Reseñas' },
      { path: '/emojis', icon: '😊', label: 'Banco Emojis' },
      { path: '/google', icon: '📈', label: 'Google / Medición' },
      { path: '/rifa', icon: '🎡', label: 'Rifa / Ruleta' },
      { path: '/clientes', icon: '👥', label: 'Clientes' },
    ],
  },
  {
    titulo: 'Administración',
    items: [
      { path: '/productos', icon: '🔋', label: 'Productos' },
      { path: '/categorias', icon: '🏷️', label: 'Categorías' },
      { path: '/servicios', icon: '🔧', label: 'Servicios' },
      { path: '/cotizaciones', icon: '💬', label: 'Cotizaciones' },
      { path: '/informacion', icon: '📍', label: 'Información' },
      { path: '/agente-ia', icon: '🤖', label: 'Agente IA' },
      { path: '/distribuidores', icon: '🗺️', label: 'Distribuidores' },
      { path: '/tecnico', icon: '🔩', label: 'Módulo Técnico' },
      { path: '/mercadeo', icon: '📣', label: 'Módulo Mercadeo' },
      { path: '/marcas', icon: '🏷️', label: 'Marcas' },
      { path: '/bci', icon: '🔋', label: 'Banco BCI' },
    ],
  },
];

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  const [disco, setDisco] = useState<any>(null);
  const [menuAbierto, setMenuAbierto] = useState(false);

  useEffect(() => {
    const cargarDisco = () => {
      fetch('https://ticobaterias.com/api/sistema/disco')
        .then(r => r.json()).then(setDisco).catch(() => {});
    };
    cargarDisco();
    const interval = setInterval(cargarDisco, 30000);
    return () => clearInterval(interval);
  }, []);

  // Cerrar el menú en celular al cambiar de página
  useEffect(() => { setMenuAbierto(false); }, [location.pathname]);

  const cerrarSesion = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const renderLink = (item: MenuItem) => (
    <Link key={item.path} to={item.path}
      className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all ${
        location.pathname === item.path
          ? 'bg-rojo text-white'
          : 'text-white/60 hover:bg-white/10 hover:text-white'
      }`}>
      <span>{item.icon}</span>
      {item.label}
    </Link>
  );

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Fondo oscuro detrás del menú en celular */}
      {menuAbierto && (
        <div className="fixed inset-0 bg-black/50 z-30 md:hidden" onClick={() => setMenuAbierto(false)} />
      )}

      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-azul-dark flex flex-col transform transition-transform duration-300 md:static md:translate-x-0 ${
        menuAbierto ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-6 border-b border-white/10 flex justify-between items-start">
          <div>
            <div className="font-bold text-xl text-white">
              Tico<span className="text-rojo">Baterías</span>®
            </div>
            <div className="text-white/40 text-xs mt-1">Panel Administrativo</div>
          </div>
          <button onClick={() => setMenuAbierto(false)} aria-label="Cerrar menú"
            className="md:hidden text-white/60 hover:text-white text-3xl leading-none">×</button>
        </div>
        <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
          {renderLink(inicio)}
          {secciones.map(sec => (
            <div key={sec.titulo}>
              <div className="px-4 pt-5 pb-2 text-rojo font-extrabold text-sm tracking-wide">
                {sec.titulo}
              </div>
              <div className="space-y-1">
                {sec.items.map(renderLink)}
              </div>
            </div>
          ))}
          <div className="mt-5 flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-gray-400 opacity-60 cursor-not-allowed select-none" title="Próximamente">
            <span>🧠</span>
            Asistente memoria
            <span className="ml-auto text-xs bg-white/10 text-gray-300 px-2 py-0.5 rounded-full">Pronto</span>
          </div>
          {renderLink({ path: '/descargas', icon: '📲', label: 'Descargas' })}
        </nav>
        {disco && (
          <div className="px-4 py-3 border-t border-white/10">
            <div className="flex justify-between items-center mb-1">
              <span className="text-white/40 text-xs">Disco uploads</span>
              <span className="text-white/60 text-xs font-bold">{disco.usado_gb}GB / {disco.total_gb}GB</span>
            </div>
            <div className="w-full bg-white/10 rounded-full h-4 overflow-hidden">
              <div
                className="h-4 rounded-full transition-all duration-1000"
                style={{
                  width: `${disco.porcentaje}%`,
                  background: disco.porcentaje < 50
                    ? 'linear-gradient(90deg, #22c55e, #86efac)'
                    : disco.porcentaje < 75
                    ? 'linear-gradient(90deg, #eab308, #fde047)'
                    : 'linear-gradient(90deg, #ef4444, #f97316)',
                  boxShadow: disco.porcentaje < 50
                    ? '0 0 8px #22c55e'
                    : disco.porcentaje < 75
                    ? '0 0 8px #eab308'
                    : '0 0 8px #ef4444'
                }}
              />
            </div>
            <div className="text-white/30 text-xs mt-1 text-right">{disco.porcentaje}% usado</div>
          </div>
        )}
        <div className="p-4 border-t border-white/10">
          <button onClick={cerrarSesion}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-white/60 hover:bg-white/10 hover:text-white text-sm font-medium transition-all">
            🚪 Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto min-w-0">
        <header className="bg-white border-b border-gray-200 px-4 md:px-8 py-4 flex justify-between items-center sticky top-0 z-20">
          <div className="flex items-center gap-3">
            <button onClick={() => setMenuAbierto(true)} aria-label="Abrir menú"
              className="md:hidden text-azul text-2xl leading-none">☰</button>
            <div className="text-gray-500 text-sm">
              Bienvenido, <strong className="text-azul">{localStorage.getItem('nombre') || 'Admin'}</strong>
            </div>
          </div>
          <div className="hidden md:block text-xs text-gray-400">TicoBaterías® — Panel Admin</div>
        </header>
        <div className="p-4 md:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
